import React from 'react';
import {
    StyleSheet,
    View,
    Text,
    TouchableOpacity,
    ActivityIndicator,
} from 'react-native';
import Svg, { Image as SVGImage } from 'react-native-svg';
import { Image } from '@rneui/themed';
import { MainModal } from './Modal';
import DecisionDialog from './Dialog/DecisionDialog';
import { addDataToInfoMap } from '../utils/Utils';
import { type TableMapType, type TableType } from '../types/Table';
import { type ColumnInfoType } from 'types/ColumnInfo';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    mapContainer: {
        // flex: 1,
    },
    svg: {
        top: 0,
        left: 0,
    },
    mapImage: {
        // flex: 1,
        resizeMode: 'cover',
    },
    area: {
        position: 'absolute',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        padding: 10,
        borderRadius: 5,
    },

    imageContent: {
        aspectRatio: 1,
        width: '100%',
        justifyContent: 'center',
    },
});

interface Props {
    tableMap: TableMapType;
    setFieldValue?: (data: TableType) => void;
}

const TableSelectMap: React.FC<Props> = ({ tableMap, setFieldValue }) => {
    const svgSize = React.useRef<{ width: number; height: number } | null>(
        null
    );

    const { t } = useTranslation();
    const { currentLanguage } = useLanguage();

    const [isModalVisible, setIsModalVisible] = React.useState(false);
    const [table, setTable] = React.useState<TableType | null>(null);

    const tableColumnInfoMap = {
        name: {
            name: t('tableName'),
            type: 'text',
        },
        image: {
            name: 'Image',
            type: 'image',
        },
        capacity: {
            name: t('tableCapacity'),
            type: 'text',
        },
        description: {
            name: t('tableDescription'),
            type: 'text',
        },
        type_id: {
            name: 'Type ID',
            type: 'hidden',
        },
        id: {
            name: 'Table ID',
            type: 'hidden',
        },
    };

    const createPercentageStr = (value: number): string => {
        return `${(value * 100).toFixed(2)}%`;
    };

    const selectTable = (table: ColumnInfoType): void => {
        console.log(table);
        const value: TableType = {
            name: table.name.data as string,
            image: table.image.data as string,
            capacity: table.capacity.data as number,
            description: table.description.data as string,
            type_id: table.type_id.data as string,
            table_id: table.id.data as string,
        };

        if (setFieldValue !== undefined) setFieldValue(value);
        setIsModalVisible(false);
    };

    return (
        <View style={styles.container}>
            <MainModal
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
            >
                {table != null && (
                    <DecisionDialog
                        title={t('tableDetails')}
                        message=""
                        submitFunc={selectTable}
                        handleFinalModal={() => {
                            setIsModalVisible(false);
                        }}
                        data={addDataToInfoMap(table, tableColumnInfoMap)}
                    />
                )}
            </MainModal>
            <View
                style={styles.mapContainer}
                onLayout={(event) => {
                    const { width, height } = event.nativeEvent.layout;
                    svgSize.current = { width, height };
                    console.log('svgSize', svgSize.current);
                }}
            >
                <Svg
                    width={330}
                    height={330}
                    preserveAspectRatio="xMidYMid meet"
                >
                    <SVGImage
                        width="100%"
                        height="100%"
                        href={
                            tableMap?.image ??
                            require('../assets/not_found_image.jpg')
                        }
                        preserveAspectRatio="xMidYMid meet"
                    />
                </Svg>
                {tableMap?.table_list.map((table: TableType) => (
                    <TouchableOpacity
                        key={table.id}
                        onPress={() => {
                            setTable(table);
                            setIsModalVisible(true);
                        }}
                        style={[
                            styles.area,
                            {
                                top: createPercentageStr(table.position_rate_y),
                                left: createPercentageStr(
                                    table.position_rate_x
                                ),
                                width: 50,
                                height: 50,
                            },
                        ]}
                    >
                        <Text
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                fontSize: 8,
                            }}
                        >
                            {table.name[currentLanguage]}
                        </Text>
                        <Image
                            source={{
                                uri: table.image,
                            }}
                            containerStyle={styles.imageContent}
                            PlaceholderContent={<ActivityIndicator />}
                        />
                    </TouchableOpacity>
                ))}
            </View>
        </View>
    );
};

export default TableSelectMap;
